<template>
  <div>
    <Modal
      v-model="update_job_name_show"
      title="更新岗位"
      :footer-hide="true"
      width="400"
    >
      <div class="update_job_div">
        <span class="update_job_div_span">岗位名称：</span>

        <Input
          v-model="update_job_name_text"
          placeholder="输入岗位名称"
          style="width: 250px"
        />
      </div>
      <div class="update_job_butotn">
        <Button type="primary" @click="click_job_name_affirm">确认更新</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
  name: "update_job_name",
  data() {
    return {
      project_id: "",
      update_job_name_show: false,
      update_job_name_text: "",
      update_interview_id_list: [],
    };
  },
  methods: {
    // 更新岗位
    click_job_name_affirm(interview_status) {
      if (interview_status == undefined) {
        interview_status = 0;
      } else {
        interview_status = 1;
      }

      var that = this;
      var obj = {
        interview_id_list: this.update_interview_id_list,
        job_name: this.update_job_name_text,
        project_id: this.project_id,
        interview_status: interview_status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/dairuzhi/update_job",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });

            that.update_job_name_show = false;
            that.$emit("change", 1);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新岗位
    open(project_id, row) {
      this.project_id = project_id;
      this.update_job_name_show = true;
      this.update_job_name_text = row.job_name;
      this.update_interview_id_list = [row.interview_id];
    },
  },
};
</script>

<style scoped>
.update_job_butotn {
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
}

.update_job_div_span {
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}

.update_job_div {
  display: flex;
  align-items: center;
}
</style>
